import {Button, Card, Descriptions, Input, Spin, Table} from 'antd';
import React from "react";
import './style.css';
import moment from "moment";

class Report extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: '',
      searchedColumn: '',
    };
  }

  componentDidMount() {
    const {match, fetch} = this.props;
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
  }

  componentWillUnmount() {
    this.props.clearData();
  }

  report = (id) => {
    const {match} = this.props;
    this.props.history.push(`/asset/history-report/${id}`);
  };

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
      <div style={{padding: 8}}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{width: 188, marginBottom: 8, display: 'block'}}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          size="small"
          style={{width: 90, marginRight: 8}}
        >
          Search
        </Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{width: 90}}>
          Reset
        </Button>
      </div>
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text =>
      this.state.searchedColumn === dataIndex && text,
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({searchText: ''});
  };


  render() {
    const {data, loading} = this.props;
    let bothLocationAndClientData = [];
    let locationButNotClient = [];
    let onlyLocation = [];
    if (data && data.client && data.client._id) {
      bothLocationAndClientData = data && data.assetDetails && data.assetDetails.length && data.assetDetails.filter(item => (item.found && item.bothLocationAndClient));
      locationButNotClient = data && data.assetDetails && data.assetDetails.length && data.assetDetails.filter(item => (item.found && !item.bothLocationAndClient));
    } else {
      onlyLocation = data && data.assetDetails && data.assetDetails.length && data.assetDetails.filter(item => item.found);
    }
    const notMatchedData = data && data.assetDetails && data.assetDetails.length && data.assetDetails.filter(item => !item.found);
    const notMatchedFilter = notMatchedData && notMatchedData.length ? notMatchedData.map(item => {
      return {
        text: item.assetCode, value: item.assetCode,
      }
    }) : [];

    const matchedAsset = [
      {
        title: 'Asset Code', dataIndex: 'assetCode', key: 'matchedAssetassetCode',
        sorter: (a, b) => a.assetCode.localeCompare(b.assetCode),
        ...this.getColumnSearchProps('assetCode'),
        render: (data) => <div>{data}</div>
      },
      {
        title: 'Condition', dataIndex: 'condition', key: 'matchedAssetcondition',
        sorter: (a, b) => a.condition.localeCompare(b.condition),
        render: (data) => <div>{data && data.name}</div>
      },
      {
        title: 'Entry Type', dataIndex: 'manual', key: 'matchedAssetManual',
        render: (data) => <div>{data ? 'Manual' : 'QR Code'}</div>
      },
      {
        title: 'Found', dataIndex: 'found', key: 'notMatchedAssetfound',
        render: (data) => <div>{data ? 'YES' : 'NO'}</div>
      },
      {
        title: 'Created At', dataIndex: 'time', key: 'matchedAssettime',
        sorter: (a, b) => moment(a.time) - moment(b.time),
        render: (data) => <div>{data ? moment(data).format('DD-MM-YYYY hh:mm a') : ''}</div>
      },

      {
        title: 'Photos', dataIndex: 'photos', key: 'matchedAssetphotos',
        render: (data) => <div>{
          data && data.length ? data.map((item, index) => <a style={{display: 'block'}} key={index} href={`${item.url}`}
                                                             target='_blank'>{`Attachment${index + 1}`}</a>) : 'No Attachments'
        }</div>
      },
    ];

    const notScanned = [
      {
        title: 'Asset Code', dataIndex: 'assetCode', key: 'matchedAssetassetCode',
        sorter: (a, b) => a.assetCode.localeCompare(b.assetCode),
        ...this.getColumnSearchProps('assetCode'),
        render: (data) => <div>{data}</div>
      },
      {
        title: 'Link to Asset History', dataIndex: 'asset', key: 'assethistory',
        render: (data) => <Button onClick={this.report.bind(this, data)}>Open Asset History</Button>
      },
    ];

    const notMatchedAsset = [
      {
        title: 'Asset Code', dataIndex: 'assetCode', key: 'notMatchedAssetassetCode',
        sorter: (a, b) => a.assetCode.localeCompare(b.assetCode),
        filters: notMatchedFilter,
        ...this.getColumnSearchProps('assetCode'),
        render: (data) => <div>{data}</div>
      },
      {
        title: 'Condition', dataIndex: 'condition', key: 'notMatchedAssetcondition',
        sorter: (a, b) => a.condition.localeCompare(b.condition),
        render: (data) => <div>{data && data.name}</div>
      },
      {
        title: 'Entry Type', dataIndex: 'manual', key: 'matchedAssetManual',
        render: (data) => <div>{data ? 'Manual' : 'QR Code'}</div>
      },
      {
        title: 'Found', dataIndex: 'found', key: 'notMatchedAssetfound',
        render: (data) => <div>{data ? 'YES' : 'NO'}</div>
      },
      {
        title: 'Created At', dataIndex: 'time', key: 'notMatchedAssettime',
        sorter: (a, b) => moment(a.time) - moment(b.time),
        render: (data) => <div>{data ? moment(data).format('DD-MM-YYYY hh:mm a') : ''}</div>
      },
      {
        title: 'Photos', dataIndex: 'photos', key: 'notMatchedAssetphotos',
        render: (data) => <div>{
          data && data.length ? data.map((item, index) => <a style={{display: 'block'}} key={index} href={`${item.url}`}
                                                             target='_blank'>{`Attachment${index + 1}`}</a>) : 'No Attachments'
        }</div>
      },
    ];

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`}>
          <Descriptions title="Asset Stock Report" layout="vertical" bordered column={4}>
            <Descriptions.Item label="Location">{data && data.location && data.location.name}</Descriptions.Item>
            <Descriptions.Item label="Sub Location">{data && data.client && data.client.name}</Descriptions.Item>
            <Descriptions.Item label="Opened By">{data && data.user && data.user.name}</Descriptions.Item>
            <Descriptions.Item
              label="Submitted By">{data && (data.submittedBy && data.submittedBy.name || data.user && data.user.name)}</Descriptions.Item>

          </Descriptions>
          <br/>
          {
            data && data.client && data.client._id ?
              <div>
                <div className={'asset-stock-report-heading'}>Matched Both Location And Sub Location</div>
                <Table
                  style={{overflow: 'auto', marginBottom: '30px'}}
                  dataSource={bothLocationAndClientData || []}
                  columns={matchedAsset || []}
                />
                <div className={'asset-stock-report-heading'}>Matched Location But Sub Location Not Matched</div>
                <Table
                  style={{overflow: 'auto', marginBottom: '30px'}}
                  dataSource={locationButNotClient || []}
                  columns={matchedAsset || []}
                />
              </div> :
              <div>
                <div className={'asset-stock-report-heading'}>Matched Assets</div>
                <Table
                  style={{overflow: 'auto', marginBottom: '30px'}}
                  dataSource={onlyLocation || []}
                  columns={matchedAsset || []}
                />
              </div>
          }

          <div className={'asset-stock-report-heading'}>Not Matched Assets</div>
          <Table
            style={{overflow: 'auto', marginBottom: '30px'}}
            dataSource={notMatchedData || []}
            columns={notMatchedAsset || []}
          />
          <div className={'asset-stock-report-heading'}>Not Scanned Assets</div>
          <Table
            style={{overflow: 'auto', marginBottom: '30px'}}
            dataSource={data && data.notScanned || []}
            columns={notScanned || []}
          />
        </Card>
      </Spin>
    );
  }
}

export default Report;
